/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum NotificationTypeEnum {
    PortfolioValueChanged = 'portfolioValueChanged',
    PortfolioMilestoneReached = 'portfolioMilestoneReached',
    DividendPayment = 'dividendPayment'
}

export function NotificationTypeEnumFromJSON(json: any): NotificationTypeEnum {
    return NotificationTypeEnumFromJSONTyped(json, false);
}

export function NotificationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationTypeEnum {
    return json as NotificationTypeEnum;
}

export function NotificationTypeEnumToJSON(value?: NotificationTypeEnum | null): any {
    return value as any;
}

